var exports = {
  "x6": "MemberListItem.module__button___ckFTRW",
  "OG": "MemberListItem.module__nameRoleColored___ckFTRW",
  "w1": "MemberListItem.module__buttonOffline___ckFTRW",
  "dP": "MemberListItem.module__buttonContextMenuOpen___ckFTRW",
  "vs": "MemberListItem.module__memberFocusRing___ckFTRW",
  "Vg": "MemberListItem.module__grid___ckFTRW",
  "Qs": "MemberListItem.module__content___ckFTRW",
  "H": "MemberListItem.module__avatarContainer___ckFTRW",
  "TT": "MemberListItem.module__userInfoContainer___ckFTRW",
  "VW": "MemberListItem.module__nameContainer___ckFTRW",
  "UU": "MemberListItem.module__name___ckFTRW",
  "w4": "MemberListItem.module__memberCustomStatus___ckFTRW",
  "Dd": "MemberListItem.module__ownerIcon___ckFTRW",
  "j$": "MemberListItem.module__crownIcon___ckFTRW",
  "a1": "MemberListItem.module__userTag___ckFTRW",
};

module.exports = exports;
